module.exports = __webpack_public_path__ + "img/yx_pic1.69472c34.jpg";